import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

const C = {
  primary: '#2E7D32', primaryDark: '#1B5E20',
  border: '#E0E0E0', light: '#F4F6F9',
  green100: '#E8F5E9', textDark: '#212121', textMid: '#616161', textLight: '#9E9E9E',
};

const S = {
  page: { minHeight: '100vh', background: C.light },
  topbar: { height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 24px', position: 'sticky', top: 0, zIndex: 100, flexShrink: 0 },
  breadcrumb: { fontSize: 13, color: C.textLight, display: 'flex', alignItems: 'center', gap: 6 },
  breadcrumbActive: { color: C.textDark, fontWeight: 600 },
  container: { maxWidth: 920, margin: '20px auto', padding: '0 20px', paddingBottom: 40 },
  carte: { background: '#fff', borderRadius: 12, border: `0.5px solid ${C.border}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 12, overflow: 'hidden' },
  sectionHeader: { background: C.primary, color: '#fff', padding: '10px 16px', fontSize: 13, fontWeight: 700 },
  carteBody: { padding: '14px 16px' },
  grille2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  grille4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10 },
  label: { display: 'block', fontSize: 12, color: C.textMid, marginBottom: 4, fontWeight: 600 },
  input: { width: '100%', padding: '7px 10px', border: `1px solid ${C.border}`,
    borderRadius: 7, fontSize: 12, boxSizing: 'border-box', outline: 'none' },
  inputNet: { width: '100%', padding: '7px 10px', border: '1px solid #A5D6A7',
    borderRadius: 7, fontSize: 12, background: C.green100, fontWeight: 700,
    color: C.primaryDark, boxSizing: 'border-box' },
  alerte: (t) => ({
    padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: 13,
    background: t === 'succes' ? C.green100 : '#FFEBEE',
    color: t === 'succes' ? C.primaryDark : '#C62828',
    border: `1px solid ${t === 'succes' ? '#A5D6A7' : '#EF9A9A'}`,
  }),
  btnSauvegarder: { width: '100%', padding: 14, background: C.primary, color: 'white',
    border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', marginTop: 8 },
};

export default function ModifierSaisiePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get('/saisies').then(r => {
      const s = r.data.find(x => x.id === parseInt(id));
      if (s) setForm({
        bovins_brut: s.bovins_brut||0, poids_bovins: s.poids_bovins||0,
        camelins: s.camelins||0, poids_camelins: s.poids_camelins||0,
        ovins: s.ovins||0, poids_ovins: s.poids_ovins||0,
        caprins: s.caprins||0, poids_caprins: s.poids_caprins||0,
        porcins: s.porcins||0, poids_porcins: s.poids_porcins||0,
        sorties_bovins: s.sorties_bovins||0, sorties_ovins: s.sorties_ovins||0,
        sorties_caprins: s.sorties_caprins||0, sorties_porcins: s.sorties_porcins||0,
        vf_bovins: s.vf_bovins||0, vf_ovins: s.vf_ovins||0,
        vf_caprins: s.vf_caprins||0, vf_porcins: s.vf_porcins||0,
        observations: s.observations||''
      });
    });
  }, [id]);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const bovins_nets_nbr = Math.max(0, (parseInt(form?.bovins_brut)||0) - (parseInt(form?.camelins)||0) - (parseInt(form?.sorties_bovins)||0));
  const bovins_nets_poids = Math.max(0, (parseFloat(form?.poids_bovins)||0) - (parseFloat(form?.poids_camelins)||0) - (parseFloat(form?.vf_bovins)||0));

  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true);
    try {
      await api.put(`/saisies/${id}`, form);
      setMessage({ type: 'succes', texte: 'Saisie modifiée avec succès !' });
      setTimeout(() => navigate('/saisies'), 1500);
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur.' });
    } finally { setChargement(false); }
  };

  if (!form) return (
    <div style={{ minHeight: '100vh', background: C.light, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMid }}>
      ⏳ Chargement...
    </div>
  );

  return (
    <div style={S.page}>
      {/* Topbar */}
      <div style={S.topbar}>
        <div style={S.breadcrumb}>
          <span>Production</span>
          <span style={{ color: C.border }}>›</span>
          <span>Liste des saisies</span>
          <span style={{ color: C.border }}>›</span>
          <span style={S.breadcrumbActive}>Modifier la saisie N°{id}</span>
        </div>
        <button style={{ background: 'transparent', border: 'none', color: C.textMid, fontSize: 13, cursor: 'pointer' }}
          onClick={() => navigate('/saisies')}>← Retour à la liste</button>
      </div>

      <div style={S.container}>
        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}

        <form onSubmit={soumettre}>
          {/* BOVINS */}
          <div style={S.carte}>
            <div style={S.sectionHeader}>🐄 BOVINS</div>
            <div style={S.carteBody}>
              <div style={S.grille4}>
                <div><label style={S.label}>Nombre brut</label><input style={S.input} type="number" min="0" name="bovins_brut" value={form.bovins_brut} onChange={champ} /></div>
                <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="poids_bovins" value={form.poids_bovins} onChange={champ} /></div>
                <div><label style={S.label}>Sorties (têtes)</label><input style={S.input} type="number" min="0" name="sorties_bovins" value={form.sorties_bovins} onChange={champ} /></div>
                <div><label style={S.label}>Viande foraine (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_bovins" value={form.vf_bovins} onChange={champ} /></div>
              </div>
              {/* Camelins */}
              <div style={{ marginTop: 12, padding: '10px 14px', background: '#FFFDE7', borderRadius: 8, border: '1px dashed #FFCA28' }}>
                <div style={{ fontWeight: 700, color: '#F57F17', marginBottom: 8, fontSize: 12 }}>🐪 CAMELINS</div>
                <div style={S.grille2}>
                  <div><label style={S.label}>Nombre camelins</label><input style={S.input} type="number" min="0" name="camelins" value={form.camelins} onChange={champ} /></div>
                  <div><label style={S.label}>Poids camelins (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="poids_camelins" value={form.poids_camelins} onChange={champ} /></div>
                </div>
              </div>
              {/* Bovins nets */}
              <div style={{ marginTop: 12, padding: '10px 14px', background: C.green100, borderRadius: 8, border: '1px solid #A5D6A7' }}>
                <div style={{ fontWeight: 700, color: C.primaryDark, marginBottom: 8, fontSize: 12 }}>✅ BOVINS NETS</div>
                <div style={S.grille2}>
                  <div><label style={S.label}>Nombre net</label><input style={S.inputNet} type="number" value={bovins_nets_nbr} readOnly /></div>
                  <div><label style={S.label}>Poids net (kg)</label><input style={S.inputNet} type="number" value={bovins_nets_poids} readOnly /></div>
                </div>
              </div>
            </div>
          </div>

          {/* OVINS */}
          <div style={S.carte}>
            <div style={S.sectionHeader}>🐑 OVINS</div>
            <div style={S.carteBody}>
              <div style={S.grille4}>
                <div><label style={S.label}>Nombre brut</label><input style={S.input} type="number" min="0" name="ovins" value={form.ovins} onChange={champ} /></div>
                <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="poids_ovins" value={form.poids_ovins} onChange={champ} /></div>
                <div><label style={S.label}>Sorties (têtes)</label><input style={S.input} type="number" min="0" name="sorties_ovins" value={form.sorties_ovins} onChange={champ} /></div>
                <div><label style={S.label}>Viande foraine (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_ovins" value={form.vf_ovins} onChange={champ} /></div>
              </div>
            </div>
          </div>

          {/* CAPRINS */}
          <div style={S.carte}>
            <div style={S.sectionHeader}>🐐 CAPRINS</div>
            <div style={S.carteBody}>
              <div style={S.grille4}>
                <div><label style={S.label}>Nombre brut</label><input style={S.input} type="number" min="0" name="caprins" value={form.caprins} onChange={champ} /></div>
                <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="poids_caprins" value={form.poids_caprins} onChange={champ} /></div>
                <div><label style={S.label}>Sorties (têtes)</label><input style={S.input} type="number" min="0" name="sorties_caprins" value={form.sorties_caprins} onChange={champ} /></div>
                <div><label style={S.label}>Viande foraine (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_caprins" value={form.vf_caprins} onChange={champ} /></div>
              </div>
            </div>
          </div>

          {/* PORCINS */}
          <div style={S.carte}>
            <div style={S.sectionHeader}>🐖 PORCINS</div>
            <div style={S.carteBody}>
              <div style={S.grille4}>
                <div><label style={S.label}>Nombre brut</label><input style={S.input} type="number" min="0" name="porcins" value={form.porcins} onChange={champ} /></div>
                <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="poids_porcins" value={form.poids_porcins} onChange={champ} /></div>
                <div><label style={S.label}>Sorties (têtes)</label><input style={S.input} type="number" min="0" name="sorties_porcins" value={form.sorties_porcins} onChange={champ} /></div>
                <div><label style={S.label}>Viande foraine (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_porcins" value={form.vf_porcins} onChange={champ} /></div>
              </div>
            </div>
          </div>

          {/* Observations */}
          <div style={S.carte}>
            <div style={S.sectionHeader}>📝 Observations</div>
            <div style={S.carteBody}>
              <textarea style={{ ...S.input, height: 80, resize: 'vertical' }} name="observations" value={form.observations} onChange={champ} />
            </div>
          </div>

          <button type="submit" style={S.btnSauvegarder} disabled={chargement}>
            {chargement ? '⏳ Sauvegarde...' : '💾 SAUVEGARDER LES MODIFICATIONS'}
          </button>
        </form>
      </div>
    </div>
  );
}
